
import React from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface EligibilityCriteriaSectionProps {
  formValues: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  handleTierChange: (value: string) => void;
  handleCheckboxChange: (name: string, checked: boolean) => void;
}

const EligibilityCriteriaSection: React.FC<EligibilityCriteriaSectionProps> = ({
  formValues,
  handleInputChange,
  handleTierChange,
  handleCheckboxChange
}) => {
  const { t } = useTranslationUtils();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">{t('admin.eligibilityCriteria', 'Eligibility Criteria')}</h3>
      
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="eligibility_min_points">{t('admin.minimumPoints', 'Minimum Points')}</Label>
          <Input
            id="eligibility_min_points"
            name="eligibility_min_points"
            type="number"
            min="0"
            value={formValues.eligibility_criteria.min_points}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="eligibility_min_tier">{t('admin.minimumTier', 'Minimum Tier')}</Label>
          <Select 
            value={formValues.eligibility_criteria.min_tier}
            onValueChange={handleTierChange}
          >
            <SelectTrigger id="eligibility_min_tier">
              <SelectValue placeholder={t('admin.selectTier', 'Select tier')} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="standard">{t('admin.tierStandard', 'Standard')}</SelectItem>
              <SelectItem value="silver">{t('admin.tierSilver', 'Silver')}</SelectItem>
              <SelectItem value="gold">{t('admin.tierGold', 'Gold')}</SelectItem>
              <SelectItem value="platinum">{t('admin.tierPlatinum', 'Platinum')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      
      <div className="flex items-center space-x-2">
        <Checkbox 
          id="eligibility_activity_required"
          checked={formValues.eligibility_criteria.activity_required}
          onCheckedChange={(checked) => 
            handleCheckboxChange('eligibility_activity_required', checked as boolean)
          }
        />
        <Label htmlFor="eligibility_activity_required">
          {t('admin.requireRecentActivity', 'Require recent activity')}
        </Label>
      </div>
      
      {formValues.eligibility_criteria.activity_required && (
        <div className="pl-6">
          <div className="space-y-2">
            <Label htmlFor="eligibility_activity_days">{t('admin.activityWithinDays', 'Activity within days')}</Label>
            <Input
              id="eligibility_activity_days"
              name="eligibility_activity_days"
              type="number"
              min="1"
              value={formValues.eligibility_criteria.activity_days}
              onChange={handleInputChange}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EligibilityCriteriaSection;
